import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  rootContainer: {
    padding: theme.spacing(0, 17.5, 0),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 4),
    },
  },
  imgContainer: {
    position: 'relative',
    maxWidth: '856px',
    height: '548.84px',
    borderRadius: '34px',
    transform: 'rotate(-7.18deg)',
    margin: 'auto',
    [theme.breakpoints.down('md')]: {
      margin: '0 30px',
    },
    [theme.breakpoints.down('sm')]: {
      margin: 'auto',
      width: '338.01px',
      height: '216.52px',
    },

    img: {
      borderRadius: '20px',
    },
  },
}))

export default useStyles
